import { getLandingExampleQuery } from "./mailAttribution.js";

const LOGIN_EXAMPLE_KEY = "lawlow.loginLandingExample";
const LOGIN_EXAMPLE_TTL = 10 * 60 * 1000;

// Carry only the public link template, never a question edited in the form.
export const landingExampleSearch = (search) => {
  const example = getLandingExampleQuery(search);
  if (!example) return "";
  const source = new URLSearchParams(search);
  const result = new URLSearchParams();
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "mail_ref"].forEach((key) => {
    const value = source.get(key);
    if (value) result.set(key, value.slice(0, 200));
  });
  result.set("example_query", example);
  if (source.get("internal_test") === "1") result.set("internal_test", "1");
  return `?${result.toString()}`;
};

export const landingEntryPath = (path, search) => {
  const exampleSearch = landingExampleSearch(search);
  if (exampleSearch) return `${path}${exampleSearch}`;
  return `${path}${new URLSearchParams(search).get("internal_test") === "1" ? "?internal_test=1" : ""}`;
};

export const rememberLandingExampleForLogin = (search) => {
  try {
    const value = landingExampleSearch(search);
    if (value) {
      sessionStorage.setItem(LOGIN_EXAMPLE_KEY, JSON.stringify({ search: value, savedAt: Date.now() }));
    } else {
      sessionStorage.removeItem(LOGIN_EXAMPLE_KEY);
    }
  } catch (_) {
    // Unavailable browser storage must not block login.
  }
};

export const consumeLandingExampleAfterLogin = () => {
  try {
    const raw = sessionStorage.getItem(LOGIN_EXAMPLE_KEY);
    sessionStorage.removeItem(LOGIN_EXAMPLE_KEY);
    const saved = JSON.parse(raw);
    if (!saved || !Number.isFinite(saved.savedAt) || Date.now() - saved.savedAt < 0 || Date.now() - saved.savedAt > LOGIN_EXAMPLE_TTL) return "";
    return landingExampleSearch(saved.search);
  } catch (_) {
    return "";
  }
};
